export default __webpack_public_path__ + "static/stock-877421550de80cc0f6c91026c1c0064d.png";